export default __webpack_public_path__ + "static/media/eye-placeholder.4c92b855.jpg";